import { useState } from "react";
import { useLang } from "../../../services/lang";
import { api, handleError } from "../../../services/api";
import { ThemeSelect } from "../../../components/Theme";
import { Input } from "../../../components/Form";
import { Loading } from "../../../components";
import { TeamPreview } from "../../../../types";

export function EditTeam({ _id, onSuccess, ...defaultTeam }: TeamPreview & { _id?: string, onSuccess: (id: string) => void }) {
    const { dict } = useLang();

    const [team, setTeam] = useState(defaultTeam);
    const [errorMessage, setErrorMessage] = useState("");
    const [isSending, setIsSending] = useState(false);

    let message = "";

    async function handleSave() {
        if (message) return;

        setIsSending(true);
        setErrorMessage("");

        const [id, error] = _id
            ? await api.updateTeam({ ...team, _id })
            : await api.addTeam({ _id: "", ...team });

        if (error) {
            handleError(error);
            setErrorMessage(dict.teamErrorMessage);
        } else {
            const teamId = id || _id;
            if (!teamId) throw new Error("Unreachable | team id");
            onSuccess(teamId);
        }

        setIsSending(false);
    }

    return <>
        <h2>{_id ? dict.teamEdit : dict.teamCreate}</h2>
        <form onSubmit={e => {
            e.preventDefault();
            handleSave();
        }}>
            <Input autoFocus label={dict.teamName} field="title" maxLength={50} required value={team} setValue={setTeam} />

            <label>{dict.theme}</label>
            <ThemeSelect
                value={team.theme}
                onChange={theme => setTeam({ ...team, theme })}
            />
            <Input type="textarea" label={dict.teamFormDescription} field="description" maxLength={500} value={team} setValue={setTeam} />

            {errorMessage && <div className="alert">{errorMessage}</div>}

            {isSending && <Loading />}
            {!isSending && <>
                <p className="info">{message}</p>
                <button disabled={!!message} className="width" onClick={handleSave}>
                    {_id ? dict.save : dict.teamCreateButton}
                </button>
            </>}
        </form>
    </>;
}
